import { ThreadProvider } from './ThreadContext';
import ChatComponent from './ChatComponent';
import './index.css';

function App() {
  return (
        <div className="flex flex-col min-h-screen bg-overlay-background bg-no-repeat bg-cover bg-left">
        <main className="flex-grow w-full max-w-4xl p-4 mx-auto">
          <ThreadProvider>
            <ChatComponent />
          </ThreadProvider>
        </main>
      </div>
  );
}

export default App;
